import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import {
  CancellationReason,
  cancellationReasons,
  CANCELLATION_REASON_OTHER,
} from '../SubscriptionInfo/SubscriptionInfo';

interface CancellationReasonsProps {
  cancelCode: CancellationReason;
  setCancelCode: (code: string) => void;
  setJustification: (justification: string) => void;
}

export const CancellationReasons = ({
  cancelCode,
  setCancelCode,
  setJustification,
}: CancellationReasonsProps) => {
  const { t } = useTranslation();
  const justificationInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (cancelCode === CANCELLATION_REASON_OTHER) {
      justificationInputRef.current?.focus();
    } else {
      setJustification('');
    }
  }, [cancelCode]);

  return (
    <div className="cancellation-reasons">
      <h2>{t('subDetails.sub.info.cancelCta.reasons.reasonListLabel')}</h2>
      <ul>
        {cancellationReasons.map((reason) => (
          <li key={reason}>
            <label htmlFor={`reason-${reason}`} className="radio-label">
              <input
                className="radio-input"
                type="radio"
                name="cancellation-reason"
                value={reason}
                id={`reason-${reason}`}
                checked={cancelCode === reason}
                onChange={() => setCancelCode(reason)}
              />
              {t(`subDetails.sub.info.cancelCta.reasons.items.${reason}`)}
            </label>
            {reason === CANCELLATION_REASON_OTHER &&
              cancelCode === CANCELLATION_REASON_OTHER && (
                <input
                  ref={justificationInputRef}
                  type="text"
                  id="cancellation-justification"
                  aria-label={t(
                    'subDetails.sub.info.cancelCta.reasons.justificationLabel'
                  )}
                  placeholder={t(
                    'subDetails.sub.info.cancelCta.reasons.justificationPlaceholder'
                  )}
                  maxLength={300}
                  onChange={(e) => setJustification(e.target.value)}
                />
              )}
          </li>
        ))}
      </ul>
    </div>
  );
};
